import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ padding: 48, textAlign: "center", fontFamily: "'Jua','Inter',sans-serif" }}>
      <div style={{ fontSize: 44, color: "#F0504E" }}>404</div>
      <p style={{ color: "#A98C88", fontSize: 14 }}>페이지를 찾을 수 없습니다.</p>
      <Link to="/sessions" style={{ color: "#F0504E", fontWeight: 700 }}>← 세션으로 돌아가기</Link>
    </div>
  );
}
